import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalActionService } from '../modal-action/modal-action.service';
import { DateTime } from 'luxon';
import { DecimalPipe } from '@angular/common';
import * as JSPM from 'jsprintmanager';

@Component({
  selector: 'jspm-print-ticket',
  templateUrl: './jspm-print-ticket.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JspmPrintTicketComponent implements OnChanges {
  @Input('printers') printers: any[] = [];
  @Input('sales') sales: any[] = [];
  @Input('tickets') tickets: any[] = [];
  @Input('experienceData') experienceData: any = null;
  selectedPrinter: any;
  isDefaultPrinterSelected = false;
  saleForm: FormGroup;

  @Output('printTicketsEventEmitter') printTicketsEventEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    private modalAction: ModalActionService,
    private decimalPipe: DecimalPipe,
  ) {
    this.saleForm = this.formBuilder.group({
      selectedPrinter: [null, [Validators.required]],
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['printers'].firstChange) {
      this.jspmOpen().then(() => {console.log(this.printers);});
    }
  }

  async jspmOpen(){
    // WebSocket settings
    JSPM.JSPrintManager.auto_reconnect = true;
    JSPM.JSPrintManager.start().then(async r => {console.log(r)});
    if (JSPM.JSPrintManager.WS) {
      JSPM.JSPrintManager.WS.onStatusChanged = () => {
        // console.log(this.jspmWSStatus());
        if (this.jspmWSStatus()) {
          // get client installed printers
          // @ts-ignore
          JSPM.JSPrintManager.getPrinters().then((myPrinters: string[]) => {
            this.printers = myPrinters;
            // console.log(this.printers);
          });
        }
      }
    }
  }

  // Check JSPM WebSocket status
  // @ts-ignore
  jspmWSStatus() {
    if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open) {
      return true;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Closed) {
      this.modalAction.openDialog({
        title: 'Error',
        message: `JSPrintManager (JSPM) no está instalado o no está corriendo. Descarga JSPM Client App de https://neodynamic.com/downloads/jspm`,
        icon: 'error',
        closeOnEscape: true
      });
      return false;
    } else if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Blocked) {
      this.modalAction.openDialog({
        title: 'Error',
        message: `JSPM ha bloqueado este sitio web`,
        icon: 'error',
        closeOnEscape: true
      });
      return false;
    }
  }

  // Do Zebra ZPL printing...
  async doPrintZPL() {
    // console.log(this.selectedPrinter);
    // console.log(this.saleForm.controls['selectedPrinter'].value);
    this.selectedPrinter = this.saleForm.controls['selectedPrinter'].value;
    if (this.selectedPrinter !== 'undefined' && this.jspmWSStatus()) {
      // Create a ClientPrintJob
      const cpj = new JSPM.ClientPrintJob();
      // Set Printer type (Refer to the help, there many of them!)
      // https://www.neodynamic.com/Products/Help/JSPrintManager4.0/articles/jsprintmanager.html#client-printer-types
      if ( this.isDefaultPrinterSelected ) {
        cpj.clientPrinter = new JSPM.DefaultPrinter();
      } else {
        cpj.clientPrinter = new JSPM.InstalledPrinter(this.selectedPrinter);
      }

      // console.log(this.experienceData);
      // console.log(this.sales);
      console.log(this.tickets);

      let experience_name = this.experienceData.name;
      if (this.experienceData.ticket_title !== null || this.experienceData.ticket_title !== '') {
        experience_name = this.experienceData.ticket_title;
      }

      let cmds = '';
      let template = this.experienceData.ticket_template.template;

      for (const ticket of this.tickets) {
        const qr_url = location.origin + '/sale-validate/' + ticket.code; // Consulted (05-2024) in: https://stackoverflow.com/questions/51984268/how-to-get-base-url-in-angular-5

        // Set content to print...
        if (this.experienceData.ticket_template.name === 'Ticket Mexico') {
          cmds += template
            .replace(/{{ticket_seat_id}}/gi, ticket.seat_id)
            .replace(/{{ticket_zone_name}}/gi, ticket.zone.name)
            .replace(/{{ticket_price}}/gi, ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.price, '1.2-2', 'en-US')  + ' ' + ticket.function.currency_function[0].currency.description)
            .replace(/{{venue_name}}/gi, ticket.function.layout.venue.name)
            .replace(/{{function_start_date}}/gi, DateTime.fromISO(ticket.function.start_date).setLocale('es').toFormat('ccc').toUpperCase() + ' ' + DateTime.fromISO(ticket.function.start_date).toFormat('dd/MM'))
            .replace(/{{function_start_hour}}/gi, DateTime.fromISO(ticket.function.start_date).toFormat('HH:mm'))
            .replace(/{{experience_name}}/gi, experience_name)
            .replace(/{{qr_url}}/gi, qr_url); // Consulted (05-2024) in: https://www.tutorialspoint.com/typescript/typescript_string_replace.htm

          // cmds += '<DI>' +
          //   '<NR><RC340,50><F2><HW1,1><CR>' +
          //   '<NR><RC362,125><F2><HW1,1><CR>' +
          //   '<NR><RC215,20><F2><HW1,1>' + ticket.seat_id + '<CR>' +
          //   '<NR><RC230,20><F2><HW1,1>' + ticket.zone.name + '<CR>' +
          //   '<NR><RC245,20><F2><HW1,1>PRECIO:<CR>' +
          //   '<NR><RC245,100><F2><HW1,1>' + ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.price, '1.2-2', 'en-US') + ' ' + ticket.function.currency_function[0].currency.description + '<CR>' +
          //   '<NR><RC110,200><F3><HW1,1>' + ticket.function.layout.venue.name + '<CR>' +
          //   '<EI>' +
          //   '<NR><RC160,260><F3><HW1,1>FECHA:<CR>' +
          //   '<DI>' +
          //   '<NR><RC200,260><F3><HW1,1>' + DateTime.fromISO(ticket.function.start_date).toFormat('dd/MM/yyyy') + '<CR>' +
          //   '<EI>' +
          //   '<NR><RC250,260><F3><HW1,1>HORA:<CR>' +
          //   '<DI>' +
          //   '<NR><RC290,260><F3><HW1,1>' + DateTime.fromISO(ticket.function.start_date).toFormat('HH:mm') + '<CR>' +
          //   '<EI>' +
          //   '<DI>' +
          //   '<NR><RC510,260><F6><HW1,1><CR>' +
          //   '<EI>' +
          //   '<NR><RC160,510><F3><HW1,1>ZONA:<CR>' +
          //   '<DI>' +
          //   '<NR><RC200,510><F3><HW1,1>' + ticket.zone.name + '<CR>' +
          //   '<EI>' +
          //   '<NR><RC250,510><F3>ENTRADA:<HW1,1><CR>' +
          //   '<DI>' +
          //   '<NR><RC290,510><F3>' + ticket.seat_id + '<HW1,1><CR>' +
          //   '<EI>' +
          //   '<NR><RC330,1050><F3><HW1,1><CR>' +
          //   '<DI>' +
          //   '<NR><RC380,1050><F3><HW1,1><CR>' +
          //   '<NR><RC30,950><F2><HW1,1>FECHA:<CR>' +
          //   '<NR><RC30,1030><F2><HW1,1>' + DateTime.fromISO(ticket.function.start_date).toFormat('dd/MM/yyyy') + '<CR>' +
          //   '<NR><RC45,950><F2><HW1,1>HORA:<CR>' +
          //   '<NR><RC45,1030><F2><HW1,1>' + DateTime.fromISO(ticket.function.start_date).toFormat('HH:mm') + '<CR>' +
          //   '<NR><RC70,950><F2><HW1,1>ENTRADA:<CR>' +
          //   '<NR><RC70,1030><F2><HW1,1>' + ticket.seat_id + '<CR>' +
          //   '<NR><RC85,950><F2><HW1,1>ZONA:<CR>' +
          //   '<NR><RC85,1030><F2><HW1,1>' + ticket.zone.name + '<CR>' +
          //   '<NR><RC100,950><F2><HW1,1>PRECIO:<CR>' +
          //   '<NR><RC100,1030><F2><HW1,1>' + ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.price, '1.2-2', 'en-US') + ' ' + ticket.function.currency_function[0].currency.description + '<CR>' +
          //   '<NR><RC105,1570><F2><HW1,1><CR>' +
          //   '<EI>' +
          //   '<NR><RC45,200><F3><HW1,1>' + experience_name + '<CR>' +
          //   '<DI>' +
          //   '<RC180,1000><QR4>{' + qr_url + '}' +
          //   '<p><CR>';
        } else if (this.experienceData.ticket_template.name === 'Ticket Mexico Goliiive') {
          let ticket_price;
          if (ticket.ticket_type.id === 1) { // Ticket normal
            ticket_price = ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.price, '1.2-2', 'en-US')  + ' ' + ticket.function.currency_function[0].currency.description;
          } else if (ticket.ticket_type.id === 2) { // Ticket cortesia
            ticket_price = 'CORTESÍA';
          }

          cmds += template
            .replace(/{{venue_name}}/gi, ticket.function.layout.venue.name)
            .replace(/{{function_start_date}}/gi, DateTime.fromISO(ticket.function.start_date).setLocale('es').toFormat('ccc').toUpperCase() + ' ' + DateTime.fromISO(ticket.function.start_date).toFormat('dd/MM'))
            .replace(/{{function_start_hour}}/gi, DateTime.fromISO(ticket.function.start_date).toFormat('HH:mm'))
            .replace(/{{user_name}}/gi, ticket.user_name)
            .replace(/{{ticket_zone_name}}/gi, ticket.zone.name)
            .replace(/{{ticket_seat_id}}/gi, ticket.seat_id)
            .replace(/{{ticket_code}}/gi, ticket.code)
            .replace(/{{ticket_price}}/gi, ticket_price)
            .replace(/{{experience_name}}/gi, experience_name)
            .replace(/{{qr_url}}/gi, qr_url); // Consulted (05-2024) in: https://www.tutorialspoint.com/typescript/typescript_string_replace.htm
        } else if (this.experienceData.ticket_template.name === 'Ticket Venezuela') {
          cmds += template
            .replace(/{{ticket_seat_id}}/gi, ticket.seat_id)
            .replace(/{{ticket_zone_name}}/gi, ticket.zone.name)
            .replace(/{{ticket_price}}/gi, ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.price, '1.2-2', 'en-US')  + ' ' + ticket.function.currency_function[0].currency.description)
            .replace(/{{venue_name}}/gi, ticket.function.layout.venue.name)
            .replace(/{{function_start_date}}/gi, DateTime.fromISO(ticket.function.start_date).setLocale('es').toFormat('ccc').toUpperCase() + ' ' + DateTime.fromISO(ticket.function.start_date).toFormat('dd/MM'))
            .replace(/{{function_start_hour}}/gi, DateTime.fromISO(ticket.function.start_date).toFormat('HH:mm'))
            .replace(/{{user_name}}/gi, ticket.user_name)
            .replace(/{{experience_name}}/gi, experience_name)
            .replace(/{{qr_url}}/gi, qr_url); // Consulted (05-2024) in: https://www.tutorialspoint.com/typescript/typescript_string_replace.htm

          if (ticket.payment.payment_detail[0].payment_detail_type.code === 'goliiive_comission') {
            cmds = cmds
              .replace(/{{goliiive_comission}}/gi, '<NR><RC460,180><F2><HW1,1>COMISIÓN:<CR><NR><RC460,260><F2><HW1,1>' + ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.payment.payment_detail[0].amount, '1.2-2', 'es-VE') + '<CR>')
              .replace(/{{goliiive_comission_2}}/gi, '<NR><RC115,1500><F2><HW1,1>COMISIÓN:<CR><NR><RC115,1580><F2><HW1,1>' + ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.payment.payment_detail[0].amount, '1.2-2', 'es-VE') + '<CR>');
          } else {
            cmds = cmds
              .replace(/{{goliiive_comission}}/gi, '')
              .replace(/{{goliiive_comission_2}}/gi, '');
          }

          if (ticket.payment.payment_detail[0].payment_detail_type.code === 'goliiive_iva') {
            cmds = cmds
              .replace(/{{goliiive_iva}}/gi, '<NR><RC475,180><F2><HW1,1>IVA:<CR><NR><RC475,260><F2><HW1,1>' + ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.payment.payment_detail[0].amount, '1.2-2', 'es-VE') + '<CR>')
              .replace(/{{goliiive_iva_2}}/gi, '<NR><RC130,1500><F2><HW1,1>IVA:<CR><NR><RC130,1580><F2><HW1,1>' + ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.payment.payment_detail[0].amount, '1.2-2', 'es-VE') + '<CR>');
          } else {
            cmds = cmds
              .replace(/{{goliiive_iva}}/gi, '')
              .replace(/{{goliiive_iva_2}}/gi, '');
          }

          if (ticket.payment.payment_detail[0].payment_detail_type.code === 'production_municipal_tax') {
            cmds = cmds
              .replace(/{{production_municipal_tax}}/gi, '<NR><RC490,180><F2><HW1,1>IEP:<CR><NR><RC490,260><F2><HW1,1>' + ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.payment.payment_detail[0].amount, '1.2-2', 'es-VE') + '<CR>')
              .replace(/{{production_municipal_tax_2}}/gi, '<NR><RC145,1500><F2><HW1,1>IEP:<CR><NR><RC145,1580><F2><HW1,1>' + ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.payment.payment_detail[0].amount, '1.2-2', 'es-VE') + '<CR>');
          } else {
            cmds = cmds
              .replace(/{{production_municipal_tax}}/gi, '')
              .replace(/{{production_municipal_tax_2}}/gi, '');
          }

          if (ticket.payment.payment_detail[0].payment_detail_type.code === 'igtf') {
            cmds = cmds
              .replace(/{{igtf}}/gi, '<NR><RC505,180><F2><HW1,1>IGTF:<CR><NR><RC505,260><F2><HW1,1>' + ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.payment.payment_detail[0].amount, '1.2-2', 'es-VE') + '<CR>')
              .replace(/{{igtf_2}}/gi, '<NR><RC160,1500><F2><HW1,1>IGTF:<CR><NR><RC160,1580><F2><HW1,1>' + ticket.function.currency_function[0].currency.symbol + this.decimalPipe.transform(ticket.payment.payment_detail[0].amount, '1.2-2', 'es-VE') + '<CR>');
          } else {
            cmds = cmds
              .replace(/{{igtf}}/gi, '')
              .replace(/{{igtf_2}}/gi, '');
          }
        }
      }

      // var cmds = '';
      // cmds += '<RL><RC360,10><F3><HW1,1>GHOSTWRITER WORLD';
      // cmds += '<RC380,76><F6><HW1,1><BS26,44>ALL<F2>';
      // cmds += '<F6><BS26,44>THREE<F2>  <F6><BS26,44>PARKS';
      // cmds += '<RC348,130><F6><HW1,1><BS42,44>PASSPORT';
      // cmds += '<RC324,240><RL><F6><HW2,2>6';
      // cmds += '<RC210,240><HW1,1>DAY';
      // cmds += '<RC230,290><F3><HW1,1>ADMIT ONE';
      // cmds += '<RC230,320><F6><HW1,1>GUEST';
      // cmds += '<F1><RC230,370><F1><HW1,1>VERY SMALL PRINT';
      // cmds += '<RC24,530><LT2><BX340,50>';
      // cmds += '<RC25,528><LT2><VX338>';
      // cmds += '<RC216,550><HW1,1><F2>DAY  1';
      // cmds += '<RC24,580><LT2><BX340,50>';
      // cmds += '<RC216,600>DAY  2';
      // cmds += '<RC24,630><LT2><BX340,50>';
      // cmds += '<RC216,650>DAY  3';
      // cmds += '<RC24,680><LT2><BX340,50>';
      // cmds += '<RC216,700>DAY  4';
      // cmds += '<RC24,730><LT2><BX340,50>';
      // cmds += '<RC25,780><LT2><VX338>';
      // cmds += '<RC216,760>DAY  5';
      // cmds += '<RC340,400><RL><F6><BS36,44><HW1,1>DAY GUEST';
      // cmds += '<RC260,450><F3><HW1,1>$112.00';
      // cmds += '<RC240,482><F3>PLUS TAX';
      // cmds += '<RC280,1010><F3><HW1,1>12345678';
      // cmds += '<RC60,990><NL10><X2>*01000407*';
      // cmds += '<RC360,820><F9><HW1,1>VALID ONLY ON DATE STAMPED';
      // cmds += 'NONTRANSFERABLE NONREFUNDABLE';
      // cmds += '<RC280,870><F3><HW1,1>01000407';
      // cmds += '<RC20,1079><RR><F3><HW1,1>GHOSTWRITER WORLD';
      // cmds += '<p>';

      if (cmds !== '') {
        cpj.printerCommands = cmds;
        console.log(cmds);

        // Send print job to printer!
        cpj.sendToClient().then(async r => {
          // console.log(r);

          this.modalAction.openDialog({
            title: 'Imprimir Ticket(s)',
            message: `Ticket(s) enviado(s) correctamente a imprimir`,
            icon: 'success',
            closeOnEscape: true
          }).then(() => {
            this.printTicketsEventEmitter.emit(true);

            this.refreshUrl();
          });
        });
      } else {
        this.modalAction.openDialog({
          title: 'Error',
          message: `Ocurrió un error imprimiendo, no hay plantilla asociada a esta Experiencia`,
          icon: 'error',
          closeOnEscape: true
        }).then(() => {
          this.printTicketsEventEmitter.emit(true);

          this.refreshUrl();
        });
      }
    } else {
      this.modalAction.openDialog({
        title: 'Error',
        message: `Ocurrió un error imprimiendo, por favor intente nuevamente`,
        icon: 'error',
        closeOnEscape: true
      }).then(() => {
        this.printTicketsEventEmitter.emit(true);

        this.refreshUrl();
      });
    }
  }

  closeprintTicketsOverlay() {
    // console.log(this.sales);
    this.sales = [];
    this.tickets = [];

    this.refreshUrl();
  }

  refreshUrl(){
    location.reload();
  }

}
